import { Form } from "react-bootstrap";

export default function SongCategorySettingsPicker({ categories, ...props }) {
    if (!categories) return null;

    return (
        <Form.Select size="sm" {...props}>
            <option value="">--</option>
            {categories.map(x => (
                <option key={x.category_id} value={x.code}>
                    [{x.code}] {x.name}
                </option>
            ))}
        </Form.Select>
    );
}
